module.exports = __webpack_public_path__ + "img/Slogan.ef65c848.png";